export default __webpack_public_path__ + "a8945929a3bc3f9637e9fdc8a7e202b8.png";